import React, {useEffect, useState} from "react";
import { onlineProcessesService } from "../../../../services";
import { QuadralLoaderProvider } from "@quadral/quadral-component-common/dist/components/loader/LoaderContext";
import QuadralButton from '@quadral/quadral-component-common/dist/components/button';
import QuadralModal from '@quadral/quadral-component-common/dist/components/modal';
import QuadralContainer from "@quadral/quadral-component-common/dist/components/container";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUserPen } from "@fortawesome/free-solid-svg-icons";

export default function AddNewDocumentModal ({open, setOpen, handlePageAssignment, setSelectedFileByDoc, dataUrlToFile, receptionBoxDisplay, unassignedAndSelectedFile, persons, receptionBox, updateData, getSupportingDocumentTypeByPerson, files, getCategory, participation, categoryLabel, ...props}) {

    const [loading, setLoading] = useState(false);
    const [supportingDocumentCategory, setSupportingDocumentCategory] = useState('');
    const [participantTitle, setParticipantTitle] = useState('');
    const [description, setDescription] = useState('');
    const [personId, setPersonId] = useState('');
    const [category, setCategory] = useState('');

    useEffect(()=>{
        switch (supportingDocumentCategory) {
            case "Justificatif_identite_Adulte": setCategory("Justificatif_identite_Adulte")
                break;
            case "Justificatif_identite_Enfant": setCategory("Justificatif_identite_Enfant")
                break;
            case "RFR": setCategory("RFR")
                break;
            case "revenus": setCategory("revenus")
                break;
            case "piece_identite": setCategory("piece_identite")
                break;
            case "Documents_complementaires": setCategory("Documents_complementaires")
                break;
            case "carte_mobilite": setCategory("carte_mobilite")
                break;
            case "Desunion": setCategory("Desunion")
                break;
            case "Union": setCategory("Union")
                break;
            case "Mode_garde": setCategory("Mode_garde")
                break;
            case "Deces": setCategory("Deces")
                break;
            default: setCategory(null)
        }
    },[supportingDocumentCategory])

    function createAndUploadSupportingDocument() {
        setLoading(true);
        const fileToUpload = files;

        const newSupportingDocument = {
            surveyParticipationId: participation.id,
            personId: personId,
            category: category,
            participantTitle: participantTitle,
            description: description,
            status: 'a_fournir'
        };
        const participationId = participation.id;

        onlineProcessesService.createSupportingDocument({ participationId : participationId, personRecordId : personId }, newSupportingDocument)
            .then(response => {
                const supportingDocumentId = response.salesforceId;
                return uploadFiles({
                    participationId,
                    personId,
                    supportingDocumentId,
                    participantTitle,
                    description,
                    files: fileToUpload
                })
            })
            .then(() => {
                updateData();
                setOpen(false);
                setLoading(false);
            })
            .catch(err => console.error(err));
    }

    function uploadFiles({participationId, personId, supportingDocumentId}){

        if(!personId || !supportingDocumentId){
            console.warn('params ou files manquant')
            return Promise.reject("Params ou files manquants");
        }

        if((!Array.isArray(files) || files.length === 0) && !receptionBoxDisplay) {
            return Promise.resolve({ skipped: true });
        }

        const formData = new FormData();
        files.forEach((item, i)=>{
            const fieldName = i === 0 ? 'file' : `file${i +1}`;
            let fileToUpload = item;

            if(typeof item === "string" && item.startsWith('data:')){
                fileToUpload = dataUrlToFile(item, fieldName);
            } else if(item && typeof item === 'object' && item.src?.startsWith('data:')){
                fileToUpload = dataUrlToFile(item.src, item.alt || fieldName);
            }
            formData.append(fieldName, fileToUpload);
        })

        return onlineProcessesService.uploadSupportingDocumentFile({ participationId, personRecordId : personId, supportingDocumentId }, formData)
        .then(()=>{
            handlePageAssignment(supportingDocumentId, files);
        })
    }
    
    return (
    <>
        {loading && <QuadralLoaderProvider/>}
        {open && (
            <QuadralModal
                title={ receptionBoxDisplay ?
                    ( <span>Association à une nouvelle pièce justificative</span> ) : 
                    ( <span>Création d’une nouvelle pièce justificative</span> ) }
                icon={<FontAwesomeIcon icon={faUserPen}/>}
                open={open}
                setOpen={setOpen}
                noButton
                action={
                    <>
                        <QuadralButton
                            size="medium"
                            color="error"
                            variant="outlined"
                            onClick={() => setOpen(false)}
                        >
                            Annuler
                        </QuadralButton>
                        <QuadralButton 
                            size="medium" 
                            color="success" 
                            variant="outlined"
                            disabled={(files?.length === 0 && receptionBoxDisplay) || (!supportingDocumentCategory || !personId)}
                            onClick={() => createAndUploadSupportingDocument()}
                        >
                            Confirmer
                        </QuadralButton>
                    </>
                }
            >
                <QuadralContainer>
                    {(files?.length === 0 && receptionBoxDisplay) && (
                        <span className="text-weight-bold">Veuillez sélectionner des pages avant d'effectuer cette opération</span>
                    )}
                    <p>Veuillez sélectionner la catégorie de la pièce justificative et la personne correspondant à ces pièces</p>
                    <div className="selections">
                        <div className="d-flex justify-content-between">
                            <div className="form-group">
                                <label>Personne</label>
                                <select 
                                    className="form-control"
                                    value={personId}
                                    onChange={(e) => setPersonId(e.target.value)}
                                    disabled={files?.length === 0 && receptionBoxDisplay}
                                >
                                    <option value="">Sélectionner</option>
                                    {persons?.map((p) => (
                                        <option key={p.id} value={p.id}>
                                            {p.firstname} {p.lastname}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            <div className="form-group">
                                <label>Catégorie</label>
                                <select 
                                    className="form-control type"
                                    value={supportingDocumentCategory}
                                    onChange={(e) => setSupportingDocumentCategory(e.target.value)}
                                    disabled={files?.length === 0 && receptionBoxDisplay}
                                >
                                    <option value="">Sélectionner</option>
                                    {categoryLabel.map((category, index) => (
                                        <option key={index} value={category.code}>
                                            {getCategory({category: category.code})}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>
                        <div className="d-flex justify-content-between c-mb-2">
                            <span className="text-3 text-italic">Pour les types Revenu fiscal de référence et justificatifs d’identité enfant/adulte, la plateforme pré-rempli le titre et la description. Pour les autres types, veuillez renseigner les informations SVP : </span>
                        </div>
                        <div className="">
                            <div className="form-group">
                                <label>Titre participant</label>
                                <input type="text" className="form-control" 
                                    onChange={(e) => setParticipantTitle(e.target.value)} 
                                    disabled={files?.length === 0 && receptionBoxDisplay}>
                                </input>
                            </div>
                        </div>
                        <div className="">
                            <div className="form-group">
                                <label>Description</label>
                                {/*<input type="text" className="form-control"*/}
                                {/*       onChange={(e) => setDescription(e.target.value)}*/}
                                {/*       disabled={files?.length === 0 && receptionBoxDisplay}>*/}
                                {/*</input>*/}
                                <textarea className="form-control"
                                          onChange={(e) => setDescription(e.target.value)}
                                          disabled={files?.length === 0 && receptionBoxDisplay}
                                          style={{ minHeight:"2rem", maxHeight:"26rem" }}>
                                        </textarea>
                            </div>
                        </div>
                    </div>
                    <div className="main" style={{display: 'flex', margin: '20px 0 30px 0'}}>
                        <div className="modal_unattachedFile-wrapper">
                            {files?.length > 0 && (
                                <>
                                {files?.map((page,index)=>(
                                    <div key={index} className="modal_unattachedFile_card"> 
                                        {page.src && (
                                            <iframe
                                                className="modal_unattachedFile"
                                                src={page.src}
                                                title={`PDF - Page ${index + 1}`}
                                                style={{
                                                    width:"200px",
                                                    height:"300px"
                                                }}
                                            ></iframe>
                                        )}
                                    </div>
                                ))}
                                </>
                            )}
                        </div>{(files?.length === 0 && receptionBoxDisplay) && (
                        <span>Veuillez sélectionner des pages avant d'effectuer cette opération</span>
                    )}
                    </div>
                </QuadralContainer>
            </QuadralModal>
        )}
    </>
  );
}